import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IQuestionBank } from 'src/app/interface/dto';
import { QuestionBankService } from '../question-bank.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Location } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { Util } from 'src/app/services/Util';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-update-question-bank',
  templateUrl: './create-update-question-bank.component.html',
  styleUrls: ['./create-update-question-bank.component.scss'],
})
export class CreateUpdateQuestionBankComponent implements OnInit {
  textDisplay = 'Add New Question Bank';
  modelError = '';
  isSave = true;

  qbCompany = '';
  uploadedJsonFileName = '';
  @ViewChild('jsonModal') jsonModal!: TemplateRef<any>;


  get isQbCompany(): boolean {
  return this.qbCompany?.toLowerCase() === Util.getSubdomain()?.toLowerCase();
}

  questionBank: IQuestionBank = {
    id: 0,
    questionBankID: 0,
    name: '',
    description: '',
    questionType: '',
    noOfQuestions: 0,
    disabled: false,
    isPsychometricTestBank: false,
    questionsJson: '',
  };

   questionTypes: any = [
    { label: "Multiple-Choice", value: "OptionsOnly" },
    { label: "Short Answer Question", value: "SAQ" },
    { label: "Essay", value: "Essay" },
  ];

  constructor(
    private questionBankService: QuestionBankService,
    private snackBar: SnackbarService,
    private actRoute: ActivatedRoute,
    private router: Router,
    private _location: Location,
     private modalService: NgbModal
  ) {}

  async ngOnInit() {
    const params = await firstValueFrom(this.actRoute.paramMap);
    const bankId = Number(params.get('questionBankID'));
    
    if (bankId && bankId !== 0) {
      this.textDisplay = 'Update Question Bank';
      this.isSave = false;
      await this.loadBankDetails(bankId);
    } else {
      this.qbCompany = await this.questionBankService.getQuestionBankCompany();
    }
  }

  async loadBankDetails(id: number) {
    try {
      const bank = await this.questionBankService.getQuestionBank(id);
      this.questionBank = { ...bank };
    } catch (error) {
      this.snackBar.error('Failed to load Question Bank details');
    }
  }

  resetForm() {
    this.questionBank = {
      id: 0,
      questionBankID: 0,
      name: '',
      description: '',
      questionType: '',
      noOfQuestions: 0,
      disabled: false,
      isPsychometricTestBank: false,
    questionsJson: '',
    };
    this.uploadedJsonFileName = '';
    this.modelError = '';
  }

  handleJsonUpload(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

   this.uploadedJsonFileName = file.name;

   const reader = new FileReader();
   reader.onload = () => {
    const jsonText = reader.result as string;
    this.questionBank.questionsJson = jsonText;

    try {
      const parsed = JSON.parse(jsonText);
    } catch (e) {
      this.questionBank.questionsJson = "";
      this.uploadedJsonFileName = "";
      this.snackBar.error("Invalid JSON format");

    }
  };
  reader.onerror = () => {
    this.snackBar.error("Failed to read JSON file");
  };
  
  reader.readAsText(file);
 }

  async saveQuestionBank(update: boolean = false) {
    this.validateModel();
    if (this.modelError !== '') {
      return;
    }

    try {
      if (update) {
        await this.questionBankService.updateQuestionBank(this.questionBank);
        this.snackBar.success('Question Bank Updated Successfully!');
      } else {
        await this.questionBankService.createQuestionBank(this.questionBank);
        this.snackBar.success('Question Bank Created Successfully!');
        this.router.navigate(['/questions-bank']);
      }
    } catch (error) {
      this.snackBar.error(error);
    }
  }

  validateModel() {
    this.modelError = '';

    if (!this.questionBank.name.trim()) {
      this.modelError += '* Name is required\n';
    }

    if (!this.questionBank.questionType.trim()) {
      this.modelError += '* Question Type is required\n';
    }

    if (this.questionBank.isPsychometricTestBank) {
      if (!this.questionBank.questionsJson || this.questionBank.questionsJson.trim() === '') {
        this.modelError += '* Psychometric Questions JSON is required\n';
      }
    }
  }

  goBack() {
    this._location.back();
  }

  onPsychometricChange() {
  if (this.questionBank.isPsychometricTestBank) {
    this.questionBank.questionType = "OptionsOnly";
  }
 }

 downloadSampleJson() {
  const sample = [
    {
      QuestionNo: 1,
      QuestionHtml: "<p>Sample question text here</p>",
      Trait: "Openness", //Openness, Conscientiousness, Extraversion, Agreeableness, Neuroticism
      IsReversed: false,
      PairId: null,
      Options: [
        { OptionHtml: "<p>Strongly Disagree</p>", Value: 1 },
        { OptionHtml: "<p>Disagree</p>", Value: 2 },
        { OptionHtml: "<p>Neutral</p>", Value: 3 },
        { OptionHtml: "<p>Agree</p>", Value: 4 },
        { OptionHtml: "<p>Strongly Agree</p>", Value: 5 }
      ]
    }
  ];

  const json = JSON.stringify(sample, null, 2);
  const blob = new Blob([json], { type: "application/json" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "big5Assessment-psychometric-sample-question.json";
  a.click();

  window.URL.revokeObjectURL(url);
 }

 prettyJson = '';

 openJsonModal() {
  try {
    const parsed = JSON.parse(this.questionBank.questionsJson);
    this.prettyJson = JSON.stringify(parsed, null, 2);
  } catch (e) {
    this.prettyJson = 'Invalid JSON format.';
  }

  this.modalService.open(this.jsonModal, { size: 'lg', scrollable: true });
 }
}
